import {
  white,
  black,
  blue,
  green,
  orange,
  red,
  purple,
  brown,
  gray,
  grey,
  stateErrorRaya,
  stateErrorSoftRaya,
  stateWarningRaya,
  stateInfoRaya,
  stateSuccessRaya,
  stateSuccessSoftRaya,
  dustyOrange,
  blueScan,
  brightCeruleaRaya,
  greyshadowSurface,
  greyshadowElevation,
  greyishSeparator,
  blueShadowBox,
  background,
  darkBackground,
  greyishContainer,
  divider,
  textPrimary,
  textSecondary,
  textDisable,
  neutralNr10,
  neutralNr20,
  neutralNr30,
  neutralNr40,
  neutralNr50,
  neutralNr60,
  neutralNr80,
  neutralNr90,
  primaryPr10,
  primaryPr20,
  primaryPr40,
  primaryPr50,
  primaryPr100,
  secondarySc10,
  secondarySc50,
  secondarySc100,
  supportGreenPantone60,
  supportBrightCerulean50,
  supportGreenPantone10,
  lightBlueSky,
  lightYellow
} from '../../common/colors';

export default {
  common: {
    white,
    black,
    blue,
    green,
    lightBlueSky,
    lightYellow,
    orange,
    red,
    purple,
    brown,
    gray,
    grey,
    dustyOrange,
    blueScan,
    brightCeruleaRaya,
    blueShadowBox,
    greyishContainer,
    greyishSeparator,
    divider,
    neutralNr20,
    neutralNr30,
    neutralNr40,
    neutralNr50,
    neutralNr60,
    neutralNr80,
    neutralNr90,
    primaryPr20,
    primaryPr40,
    supportGreenPantone60,
    supportBrightCerulean50,
    supportGreenPantone10
  },
  primary: {
    light: primaryPr10,
    main: primaryPr50,
    dark: primaryPr100,
    contrastText: white
  },
  secondary: {
    light: secondarySc10,
    main: secondarySc50,
    dark: secondarySc100,
    contrastText: white
  },
  error: {
    light: stateErrorSoftRaya,
    main: stateErrorRaya,
    dark: '',
    contrastText: white
  },
  warning: {
    light: '',
    main: stateWarningRaya,
    dark: '',
    contrastText: white
  },
  info: {
    light: '',
    main: stateInfoRaya,
    dark: '',
    contrastText: white
  },
  success: {
    light: stateSuccessSoftRaya,
    main: stateSuccessRaya,
    dark: '',
    contrastText: white
  },
  background: {
    default: background,
    dark: darkBackground,
    paper: neutralNr10
  },
  text: {
    primary: textPrimary,
    secondary: textSecondary,
    disabled: textDisable,
    error: stateErrorRaya
  },
  surface: {
    greyshadowSurface,
    greyshadowElevation
  }
};
